import {gql} from '@apollo/client';

const AttendanceScedule = gql`
    fragment AttendanceScedule on AttendanceSchedule {
        deletedAt
        fullYear
        id
        startMonth
        periods {
            from
            to
        }
        title
        behaviors {
            behaviorId
        }
        attendancePeriods {
            from
            to
        }
        nonFundablePeriods {
            from
            to
        }
    }
`;

const AttendanceScheduleBehavior = gql`
    fragment AttendanceScheduleBehavior on BehaviorVolatileInvoicePeriods {
        periods {
            from
            to
        }
    }
`;

export const AttendanceScheduleList = gql`
    query AttendanceSchedules($institutionIds: [InstitutionSetId!], $includeDeleted: Boolean!) {
        finance {
            attendanceSchedules {
                list(institutionSetIds: $institutionIds, includeDeleted: $includeDeleted) {
                    ...AttendanceScedule
                }
            }
        }
    }
    ${AttendanceScedule}
`;

export const AttendanceSchedulesByIds = gql`
    query AttendanceSchedulesByIds($attendanceScheduleIds: [AttendanceScheduleId!]!) {
        finance {
            attendanceSchedules {
                list(attendanceScheduleIds: $attendanceScheduleIds) {
                    ...AttendanceScedule
                }
            }
        }
    }
    ${AttendanceScedule}
`;

export const GetAttendanceSchedules = gql`
    query GetAttendanceSchedules($attendanceScheduleIds: [AttendanceScheduleId!]!) {
        finance {
            attendanceSchedules {
                list(attendanceScheduleIds: $attendanceScheduleIds) {
                    ...AttendanceScedule
                }
            }
        }
    }
    ${AttendanceScedule}
`;

export const SetAttendanceSchedule = gql`
    mutation SetAttendanceSchedule($attendanceSchedule: AttendanceScheduleInput!) {
        finance {
            attendanceSchedules {
                setAttendanceSchedule(attendanceSchedule: $attendanceSchedule) {
                    ...AttendanceScedule
                }
            }
        }
    }
    ${AttendanceScedule}
`;

export const DeleteAttendanceSchedule = gql`
    mutation DeleteAttendanceSchedule($attendanceScheduleIds: [AttendanceScheduleId!]!) {
        finance {
            attendanceSchedules {
                deleteAttendanceSchedules(attendanceScheduleIds: $attendanceScheduleIds)
            }
        }
    }
`;

export const AttendanceScheduleBehaviors = gql`
    query AttendanceScheduleBehaviors($attendanceScheduleIds: [AttendanceScheduleId!]!, $range: ClosedLocalDateRange!) {
        finance {
            attendanceSchedules {
                list(attendanceScheduleIds: $attendanceScheduleIds) {
                    id
                    behaviors(range: $range) {
                        behaviorId
                        ...AttendanceScheduleBehavior
                    }
                }
            }
        }
    }
    ${AttendanceScheduleBehavior}
`;
